import { ChevronRight, ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import "./style.css";

export type BreadcrumbItem = {
  label: string;
  to?: string;
  state?: unknown;
};

type Props = {
  items: BreadcrumbItem[];
  showBack?: boolean;
  className?: string;
};

// Trail styling follows the smart-solution app's UIBreadcrumb: muted link
// crumbs with a soft hover, chevron separators, and the current page as bolder,
// darker, non-clickable text. Styles live in breadcrumb/style.css.
const UIBreadcrumb = ({ items = [], showBack = true, className = "" }: Props) => {
  const navigate = useNavigate();

  const canGoBack = items.length > 1;
  const backTarget = canGoBack ? items[items.length - 2] : null;

  return (
    <nav className={`uiBreadcrumb ${className}`.trim()} aria-label="Breadcrumb">
      {showBack && (
        <button
          type="button"
          onClick={() =>
            backTarget?.to
              ? navigate(backTarget.to, { state: backTarget.state })
              : navigate(-1)
          }
          className="breadcrumbBack"
        >
          <ArrowLeft size={16} strokeWidth={2} />
          Back
        </button>
      )}

      <ol className="breadcrumbList">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;

          return (
            <li key={index} className="breadcrumbItem">
              {item.to && !isLast ? (
                <button
                  type="button"
                  onClick={() => navigate(item.to!, { state: item.state })}
                  className="breadcrumbLink"
                  title={item.label}
                >
                  <span className="breadcrumbLabel">{item.label}</span>
                </button>
              ) : (
                <span
                  className="breadcrumbLink breadcrumbLinkCurrent"
                  aria-current={isLast ? "page" : undefined}
                  title={item.label}
                >
                  <span className="breadcrumbLabel">{item.label}</span>
                </span>
              )}

              {!isLast && (
                <ChevronRight size={14} strokeWidth={2} className="breadcrumbSeparator" />
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default UIBreadcrumb;
